<template>
  <div>
    <a-row v-if="!loading" :gutter="16">
      <a-col :span="6">
        <div class="tag-list">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="handleCheckAllChange"
          >
            点击舆情事件维度筛选事件
          </a-checkbox>
          <a-divider />
          <a-checkbox-group @change="handleChangeTag" :value="checkedTags">
            <div v-for="item in tagsCount" :key="item.name" class="tag-line">
              <a-checkbox :value="item.name">
                <span class="margin-right-10">{{ item.name }}</span>
                <a-badge :count="item.value" />
              </a-checkbox>
            </div>
          </a-checkbox-group>
        </div>
      </a-col>
      <a-col :span="18">
        <a-spin :spinning="listLoading">
          <a-list
            item-layout="vertical"
            :pagination="{
              current: newsPage.currentPageNo,
              total: newsPage.recordSum,
              pageSize: newsPage.pageSize,
              showQuickJumper: true,
              onChange: page => {
                handlePageChange(page)
              },
            }"
            :data-source="newsPage.results"
          >
            <a-list-item slot="renderItem" slot-scope="item" :key="item.url">
              <a-list-item-meta :description="item.newsTags">
                <a slot="title" :href="item.url" target="_blank" class="link">
                  {{ item.title }}
                </a>
              </a-list-item-meta>
              <div class="flex-column gray">
                <div class="pub-time">{{ item.pubtime }}</div>
                <div class="source">{{ item.source }}</div>
              </div>
            </a-list-item>
          </a-list>
        </a-spin>
      </a-col>
    </a-row>
    <a-skeleton v-else />
  </div>
</template>
<script>
import { getEnterpriseNewsInfo } from './api'
export default {
  data() {
    return {
      companyName: '',
      loading: false,
      listLoading: false,
      tagsCount: [],
      newsPage: {
        currentPageNo: 1,
        recordSum: 0,
        results: [],
        pageSize: 10,
      },
      checkedTags: [],
      indeterminate: false,
      checkAll: false,
    }
  },
  watch: {
    checkedTags() {
      this.fetchEnterpriseNewsInfo()
    },
  },
  mounted() {
    this.loading = true
    this.companyName = this.$store.getters['app/company'].name
    this.fetchEnterpriseNewsInfo()
  },
  methods: {
    async fetchEnterpriseNewsInfo() {
      this.listLoading = true
      const params = {
        enterpriseName: this.companyName,
        currentPageNo: this.newsPage.currentPageNo,
        pageSize: this.newsPage.pageSize,
        newsTags: this.checkedTags.join(','),
      }
      const {
        resultData: { newsPage, tagsCount },
      } = await getEnterpriseNewsInfo(params)
      this.newsPage.results = (newsPage && newsPage.results) || []
      this.newsPage.recordSum = (newsPage && newsPage.recordSum) || 0
      !this.tagsCount.length && (this.tagsCount = tagsCount)
      this.loading && (this.loading = false)
      this.listLoading = false
    },
    handleChangeTag(checkedList) {
      const tagsCount = this.tagsCount
      this.indeterminate =
        !!checkedList.length && checkedList.length < tagsCount.length
      this.checkAll = checkedList.length === tagsCount.length
      this.checkedTags = checkedList
    },
    handleCheckAllChange(e) {
      Object.assign(this, {
        checkedTags: e.target.checked
          ? this.tagsCount.map(item => item.name)
          : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })
    },
    handlePageChange(page) {
      this.newsPage.currentPageNo = page
      this.$nextTick(() => {
        this.fetchEnterpriseNewsInfo()
      })
    },
  },
}
</script>
<style lang="less" scoped>
.flex-column {
  flex-direction: column;
  flex-basis: 120px;
}
.gray {
  color: #a5a5a5;
}
.tag-list {
  max-height: 750px;
  overflow-y: auto;
}
.tag-line {
  line-height: 2;
}
/deep/ .ant-list-items {
  max-height: 700px;
  overflow-y: auto;
}
/deep/ .ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px 12px 0;
  .ant-list-item-meta {
    margin-bottom: 0;
  }
}
.link {
  color: #1890ff;
}
</style>
